import { Link } from 'react-router';
import type { Bottle } from '../../shared/api';
import { DRINK_KIND_LABELS } from '../../shared/api';
import { describeLevel, formatSize, needsCheck, onShoppingList, pictureOf } from '../lib/bottles';
import { BottleGauge } from './BottleGauge';

interface BottleListProps {
  bottles: readonly Bottle[];
  /** Where a tile links to; omit for a read-only list (a friend's bar). */
  linkTo?: (bottle: Bottle) => string;
}

/** A grid of bottle tiles: the photo (or the gauge), name, what it is, and how much is left. */
export function BottleList({ bottles, linkTo }: BottleListProps) {
  return (
    <ul className="bottle-grid">
      {bottles.map((bottle) => {
        const body = (
          <>
            <span className="bottle-tile__visual">
              {pictureOf(bottle) && <img className="bottle-tile__photo" src={pictureOf(bottle)!} alt="" loading="lazy" decoding="async" />}
              <span className={`bottle-tile__gauge${pictureOf(bottle) ? ' bottle-tile__gauge--corner' : ''}`}>
                <BottleGauge bottle={bottle} />
              </span>
            </span>
            <span className="bottle-tile__name">{bottle.name}</span>
            <span className="muted bottle-tile__meta">
              {[bottle.variant, bottle.brand, DRINK_KIND_LABELS[bottle.kind], formatSize(bottle.sizeMl)].filter(Boolean).join(' · ')}
            </span>
            <span className="bottle-tile__level">
              {describeLevel(bottle)}
              {needsCheck(bottle) && <span className="badge badge--pending bottle-tile__flag">Check me</span>}
              {onShoppingList(bottle) && <span className="badge badge--complete bottle-tile__flag">Buy again</span>}
            </span>
          </>
        );
        return (
          <li key={bottle.id} className={`bottle-tile${bottle.quantity === 0 ? ' is-finished' : ''}`}>
            {linkTo ? (
              <Link className="bottle-tile__link" to={linkTo(bottle)}>
                {body}
              </Link>
            ) : (
              <div className="bottle-tile__link">{body}</div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
